import React from 'react';
import './TabStyles.css';

const InterviewTab = ({ candidate }) => {
    // Get interview questions if available
    const getInterviewQuestions = () => {
        if (candidate.questionnaire) {
            const questionnaire = typeof candidate.questionnaire === 'string'
                ? JSON.parse(candidate.questionnaire)
                : candidate.questionnaire;
            
            // Backward compatibility: some old flows stored a flat `questions` array.
            if (Array.isArray(questionnaire.questions) && questionnaire.questions.length > 0) {
                return questionnaire.questions;
            }

            // Current format: sectioned questionnaire (introduction/behavioral/situational/technical)
            const questions = [];

            const pushSection = (arr) => {
                if (!Array.isArray(arr)) return;
                arr.forEach((q) => {
                    if (!q) return;
                    if (typeof q === 'string') questions.push(q);
                    else if (q.question) questions.push(q.question);
                });
            };

            pushSection(questionnaire.introduction);
            pushSection(questionnaire.behavioral);
            pushSection(questionnaire.situational);
            pushSection(questionnaire.technical?.theoretical);
            pushSection(questionnaire.technical?.practical);

            return questions;
        }
        return [];
    };

    // Get interview notes
    const getInterviewNotes = () => {
        // TODO: Implement interview notes storage/retrieval
        return '';
    };

    // Get interview transcript
    const getInterviewTranscript = () => {
        // TODO: Implement interview transcript storage/retrieval
        return null;
    };

    // Get post-interview assessment
    const getPostInterviewAssessment = () => {
        // TODO: Implement post-interview assessment
        return null;
    };

    const questions = getInterviewQuestions();
    const notes = getInterviewNotes();
    const transcript = getInterviewTranscript();
    const assessment = getPostInterviewAssessment();

    return (
        <div className="tab-content interview-tab">
            {/* Generated Interview Questions */}
            {questions.length > 0 && (
                <div className="interview-section">
                    <h3 className="section-title">Generated Interview Questions</h3>
                    <ol className="questions-list">
                        {questions.map((q, idx) => (
                            <li key={idx} className="question-item">
                                {typeof q === 'string' ? q : q.question || q}
                            </li>
                        ))}
                    </ol>
                </div>
            )}

            {/* Interview Notes Editor */}
            <div className="interview-section">
                <h3 className="section-header">INTERVIEW NOTES</h3>
                <textarea
                    className="interview-notes-editor"
                    placeholder="Add your interview notes here..."
                    defaultValue={notes}
                    rows={8}
                />
                <button className="save-notes-btn">Save Notes</button>
            </div>

            {/* Transcript Upload */}
            <div className="interview-section">
                <h3 className="section-header">TRANSCRIPT</h3>
                {transcript ? (
                    <div className="transcript-display">
                        <p>{transcript}</p>
                    </div>
                ) : (
                    <div className="transcript-upload">
                        <input type="file" accept=".txt,.doc,.docx" className="transcript-file-input" />
                        <p className="upload-hint">Upload interview transcript (TXT, DOC, DOCX)</p>
                    </div>
                )}
            </div>

            {/* Post-Interview Reassessment */}
            {assessment ? (
                <div className="interview-section">
                    <h3 className="section-header">POST-INTERVIEW ASSESSMENT</h3>
                    <div className="post-interview-assessment">
                        <p>{assessment}</p>
                    </div>
                </div>
            ) : (
                <div className="interview-section">
                    <h3 className="section-header">POST-INTERVIEW RECOMMENDATION</h3>
                    <div className="recommendation-actions">
                        <button className="recommendation-btn hire-btn">✅ Hire</button>
                        <button className="recommendation-btn hold-btn">🟡 Hold</button>
                        <button className="recommendation-btn no-hire-btn">❌ No Hire</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default InterviewTab;
